export type PaymentKind = 'iscrizione' | 'lampade-votive' | 'donazione';

export interface PaymentSummary {
  kind: PaymentKind;
  title: string;
  tag: string;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  amountLabel: string;
  amountValue: string;
  extraDetailLabel?: string;
  extraDetailValue?: string;
  note?: string;
  unitCostLabel?: string;
  unitCostValue?: string;
  baseCents: number;
  feeCents: number;
  totalCents: number;
}

export const STRIPE_RATE = 0.015;
export const STRIPE_FIXED_CENTS = 25;
export const LAMP_CENTS = 2500;
export const ISCRIZIONE_MIN_CENTS = 500;
export const SERVICE_FEE_HINT = 'Costi di servizio Numia per carte europee: 1,5% + 0,25 €.';
export const CODICE_FISCALE_PATTERN = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;

const euroFormat = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
});

export function formatEuro(cents: number): string {
  return euroFormat.format(cents / 100);
}

/** Calcolo costi di servizio (formule attuali UI; tariffe da confermare con Numia in integrazione). */
export function quoteServiceFee(baseCents: number): { feeCents: number; totalCents: number } {
  const totalCents = Math.round((baseCents + STRIPE_FIXED_CENTS) / (1 - STRIPE_RATE));
  return { feeCents: totalCents - baseCents, totalCents };
}

export function parseEuroInput(value: string): number | null {
  const normalized = value.trim().replace(',', '.');
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) {
    return null;
  }
  const cents = Math.round(Number(normalized) * 100);
  return cents > 0 ? cents : null;
}

export function requireText(
  control: { setErrors: (errors: { required: true } | null) => void },
  value: string | null,
): void {
  if (!value?.trim()) {
    control.setErrors({ required: true });
  }
}
